import { isIn } from './dataUtils';
import { HistogramData, MinMonthPrices, MonthPrice, SUPPORTED_AM_LOCALES, WidgetTab } from '../common';
import { Profile } from '../interfaces';

export const getEnabledTabs = (
  locale: string,
  profile: Profile,
  enableAward = false,
  enableAwardIfLoggedIn = false,
  enableAurinkomatkat = false
): WidgetTab[] => {
  return [
    {
      tab: WidgetTab.FLIGHT,
      enabled: true,
    },
    {
      tab: WidgetTab.AWARD,
      enabled: enableAward || (profile.isLoggedIn && enableAwardIfLoggedIn),
    },
    {
      tab: WidgetTab.AM,
      enabled: enableAurinkomatkat && isIn(locale, SUPPORTED_AM_LOCALES),
    },
  ]
    .filter((t) => t.enabled)
    .map((t) => t.tab);
};

export const formatToHistogramData = (minMonthPrices: MinMonthPrices, minPrice: number): HistogramData => {
  let maxPrice = 0;

  const months = Object.keys(minMonthPrices || {}).reduce((accumulator, key, index) => {
    if (maxPrice <= +minMonthPrices[key]?.price?.amount) {
      maxPrice = +minMonthPrices[key]?.price?.amount;
    }

    accumulator.push({
      ...minMonthPrices[key],
      isCheapest: +minMonthPrices[key]?.price?.amount === minPrice,
      isSeparator: index > 0 && accumulator[index - 1]?.date?.split('-')[0] !== key?.split('-')[0],
    });

    return accumulator;
  }, [] as MonthPrice[]);

  return { months, minPrice, maxPrice };
};
